export default {
    url: '/skill',
    template: '<user-skill-list-skill classifiers="vm.classifiers"/>',
    controllerAs: 'vm',
    controller (classifiers) {
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/skill/list/skill/index.js